module.exports = __webpack_public_path__ + "public/img/empty_refrigerator-d5c1.png";